import React from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  name: 'Mariana P. Buenos Aires',
  role: 'PROFESORA DE ARTÍSTICA EN CLUB DEPORTIVO',
  quote: 'Compré un domingo a la noche. El lunes entré al gimnasio con el plan exacto de la clase. El Tomo 1 de suelo es exactamente lo que necesitaba para mis grupos de nivel inicial. Nunca más improviso.'
}, {
  initials: 'LR',
  name: 'Laura R. Rosario',
  role: 'PROFE EN ACADEMIA PARTICULAR',
  quote: 'El Tomo 2 de barra de equilibrio me cambió todo. El primer mes, alumnas que llevaban tiempo estancadas mejoraron visiblemente su técnica y confianza. Las progresiones y el protocolo de spotting son únicos.'
}, {
  initials: 'GF',
  name: 'Gabriela F. Córdoba',
  role: 'INSTRUCTORA GRUPAL E INDIVIDUAL',
  quote: 'El sistema de progresión por aparato es único en el mercado. 20 clases listas para cada aparato, con las indicaciones técnicas descriptas paso a paso. Antes tardaba horas armando una sesión. Ahora abro el PDF y en 5 minutos tengo todo listo.'
}, {
  initials: 'RP',
  name: 'Romina P. Tucumán',
  role: 'PROFE PARTICULAR Y EN CLUB',
  quote: 'Las Fichas de Seguimiento del Bono 3 eliminaron mi inseguridad al evaluar a mis alumnos. Ahora sé exactamente en qué elemento están y qué necesitan. Mis clases tienen otro nivel de profesionalismo.'
}, {
  initials: 'MG',
  name: 'Marcela G. Mendoza',
  role: 'PROFESORA DE ARTÍSTICA ONLINE Y PRESENCIAL',
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión por niveles. Los alumnos ahora quieren venir porque siempre hay algo nuevo que aprender.'
}, {
  initials: 'LV',
  name: 'Laura V. Santa Fe',
  role: 'INSTRUCTORA EN CLUB Y ACADEMIA MUNICIPAL',
  quote: 'El Tomo 6 de gestión me salvó de seguir cobrando lo mismo de siempre. Ahora tengo un sistema profesional visible que me permite justificar mis tarifas. Mi academia me reconoce como la profe más organizada del gimnasio.'
}, {
  initials: 'AR',
  name: 'Andrea R. Salta',
  role: 'INSTRUCTORA EN CLUB Y ESPACIO PRIVADO',
  quote: 'Las Coreografías del Pack Élite me cambiaron la cabeza. Nunca había dimensionado el potencial de llegar a una exhibición con todo resuelto. Ahora trabajo con una seguridad que antes no tenía.'
}];
export function ExtendedTestimonials() {
  return <Section className="bg-navy-800" data-id="element-80">
      <div className="text-center mb-6 md:mb-16" data-id="element-81">
        <h2 className="text-xl md:text-4xl font-black text-white mb-2 md:mb-4" data-id="element-82">
          LO QUE DICEN LOS PROFESORES QUE YA LO USAN
        </h2>
        <p className="text-sm md:text-xl text-gray-400" data-id="element-83">
          +300 profesores de todo el país ya tienen su Gimnasia Artística
          Resuelta™
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-6 max-w-7xl mx-auto" data-id="element-84">
        {testimonials.map((t, i) => <div key={i} className="bg-navy-900 border border-navy-700 rounded-xl md:rounded-2xl p-3 md:p-6 flex flex-col" data-id="element-85">
            <div className="flex items-center space-x-0.5 mb-2 md:mb-4" data-id="element-86">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3 h-3 md:w-4 md:h-4 fill-gold-400 text-gold-400" data-id="element-87" />)}
            </div>
            <p className="text-gray-300 mb-3 md:mb-6 flex-grow text-xs md:text-base leading-snug md:leading-normal" data-id="element-88">
              "{t.quote}"
            </p>
            <div className="flex items-center space-x-2 mt-auto pt-2 md:pt-4 border-t border-navy-800" data-id="element-89">
              <div className="w-7 h-7 md:w-10 md:h-10 rounded-full bg-navy-700 flex items-center justify-center text-white font-bold text-[10px] md:text-sm" data-id="element-90">
                {t.initials}
              </div>
              <div data-id="element-91">
                <p className="text-white font-bold text-[10px] md:text-sm" data-id="element-92">
                  {t.name}
                </p>
                <p className="text-[9px] md:text-xs text-gray-500" data-id="element-93">{t.role}</p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}